import { useEffect } from 'react'
import { useRecoilValue, useRecoilState, useSetRecoilState } from 'recoil'
import { AxiosInterceptor } from 'api/apiInterceptor'
import ModalContainer from 'components/modal/ModalContainer'
import LoadingSpanner from 'components/LoadingSpanner'
import { loadingState, sideMenuState, backPressState } from 'store/atom/app-state-atom'
import { modalState, modalOpenState } from 'store/atom/modal-state-atom'
import Router from 'router/Routes.jsx'
import { useLocation, useNavigate } from 'react-router-dom'
import { App as Application, Device } from 'native/core-plugin'
import useModal from 'hook/useModal'

// css
import 'assets/style/components/bottom-button.scss'
import 'assets/style/import.scss'
import 'assets/style/pages/elements.scss'

function App() {
  const location = useLocation()
  const navigate = useNavigate()
  const loading = useRecoilValue(loadingState)
  const [sideMenu, setSideMenuState] = useRecoilState(sideMenuState)
  const modals = useRecoilValue(modalState)
  const isModalOpen = useRecoilValue(modalOpenState)
  const setPressState = useSetRecoilState(backPressState)

  const { closeModal } = useModal()

  let isTimeout = true
  let timeoutId = -1

  useEffect(() => {
    if (modals.length === 0) {
      document.body.classList.remove('modal-open')
    }
  }, [])

  useEffect(() => {
    console.log('Location Path : ' + location.pathname)
    setSideMenuState({ isOpen: false })
    window.scrollTo(0, 0)
  }, [location.pathname])

  useEffect(() => {
    console.log('App Called...')
    // webpage 로드 완료 시(2번 호출될 수 있음!)
    // SPA의 경우 항상 호출되지 않는다.
    const onReady = () => {
      console.log('NativeEvent', 'Called onReady!')
    }

    // 앱 background 상태
    const onPause = () => {
      console.log('NativeEvent', 'Called onPause!')
    }

    // 앱 foreground 상태
    const onResume = () => {
      console.log('NativeEvent', 'Called onResume!')
    }

    // Push 수신 시
    // ex) push 수신함으로 이동 처리
    const onPush = (result) => {
      console.log('NativeEvent', JSON.stringify(result.detail))
    }

    // Android back key / iOS back gesture 발생 시
    const onBack = () => {
      const historyLen = window.history.state.idx
      console.log('NativeEvent', 'histroyLen = ' + historyLen)
      if (
        document.querySelectorAll('.calendar-modal.show').length > 0 ||
        document.querySelectorAll('.react-datepicker').length > 0
      ) {
        setPressState((prev) => !prev)
      } else if (window.self !== window.top || isModalOpen) {
        closeModal()
      } else if (sideMenu.isOpen) {
        setSideMenuState({ isOpen: false })
      } else if (location.pathname === '/login' || location.pathname === '/main') {
        if (Device.os() === 'android') {
          finish()
        }
      } else {
        navigate(-1)
      }

      function finish() {
        if (!isTimeout) {
          clearTimeout(timeoutId)
          Application.finish()
          return
        }

        timeoutId = setTimeout(() => {
          isTimeout = true
        }, 2000)

        isTimeout = false
        Application.toast('뒤로가기 버튼을 다시 클릭 시 앱이 종료됩니다.')
      }
    }

    // window.addEventListener('onReady', onReady)
    window.addEventListener('onPause', onPause)
    window.addEventListener('onResume', onResume)
    window.addEventListener('onPush', onPush)
    window.addEventListener('onBack', onBack)

    // back event를 다른 component에서 사용 시에는
    // window.removeEventListener('onBack', onBack)로 삭제 후
    // 해당 component에 addEventListener 로 등록 후 사용
    // 아래 코드는 다른 component에서 사용후 원래의 함수로 복원 시 사용
    window.onNativeBackCallback = onBack

    return () => {
      // window.removeEventListener('onReady', onReady)
      window.removeEventListener('onPause', onPause)
      window.removeEventListener('onResume', onResume)
      window.removeEventListener('onPush', onPush)
      window.removeEventListener('onBack', onBack)
    }
  }, [sideMenu, isModalOpen])

  return (
    <div className="App">
      <AxiosInterceptor>
        <Router />
        <ModalContainer />
        <LoadingSpanner isLoading={loading.isLoading} />
      </AxiosInterceptor>
    </div>
  )
}

export default App
